import React from "react";
import {
  Facebook,
  Instagram,
  Twitter,
  Youtube,
} from "lucide-react";
import logo from "@/assets/images/logo/logo-text-light.png";

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-gray-300">
      {/* Main content */}
      {/* <div className="container mx-auto px-6 py-16 grid md:grid-cols-4 gap-12">
        <div>
          <img src={logo} alt="Kaduna Business School" className="h-10 mb-5" />
          <p className="text-sm leading-relaxed text-gray-400 max-w-sm">
            Kaduna Business School (KBS) is the graduate business school of
            Pan-Atlantic University. KBS was founded on inspiration from the
            teachings of St Josemaria Escriva, the founder of Opus Dei.
          </p>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Explore</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#" className="hover:text-white transition">
                About Us
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Our Team & Governance
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Cohorts & Partners
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Gallery
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Explore</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#" className="hover:text-white transition">
                Featured Projects
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Our Team & Governance
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Cohorts & Partners
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Gallery
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Contact Us</h3>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-400">Phone</span>
              <span className="text-gray-200">123-456-7890</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Email Address</span>
              <span className="text-gray-200">123-456-7890</span>
            </div>
          </div>

          <div className="mt-6">
            <h4 className="text-white font-semibold mb-3 text-sm">Social</h4>
            <div className="flex space-x-4">
              {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="text-gray-300 hover:text-white transition"
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div> */}

      {/* Bottom Bar */}
      <div className="bg-[#7b2a40] py-4 text-center text-gray-200 text-sm">
        © {new Date().getFullYear()} Kaduna Business School. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
